import React from "react";
import {  FaChurch, FaHome  } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa6";
import { GoAlert } from "react-icons/go";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <div className=" min-h-screen">
       

        
        <div className="flex flex-col justify-center px-8 sm:px-12 lg:px-16 py-12 bg-white">
          <div className="max-w-md mx-auto w-full text-center">
            

            {/* 404 Error Display */}
            <div className="mb-8">
              <div className="w-24 h-24 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <GoAlert size={40} className="text-white" />
              </div>
              <h2 className="text-6xl font-bold text-blue-700 mb-4">404</h2>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">Page Not Found</h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                The page you're looking for doesn't exist or has been moved. 
                Don't worry, let's get you back on track.
              </p>
            </div>

            {/* Action Buttons */}
            <div className="space-y-4">
              
              
              <button
                onClick={() => window.history.back()}
                className="w-full bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 font-semibold py-3 px-4 rounded-xl transition-all duration-200 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center space-x-2"
              >
                <FaArrowLeft size={18} />
                <span>Go Back</span>
              </button>
            </div>

            {/* Help Section */}
            <div className="mt-12 p-6 bg-gray-50 rounded-xl">
              <h4 className="text-sm font-semibold text-gray-700 mb-2">Need Help?</h4>
              <p className="text-sm text-gray-600 mb-4">
                If you believe this is an error, please contact the system administrator.
              </p>
              <div className="flex items-center justify-center space-x-4 text-sm text-gray-500">
                <span>Error Code: 404</span>
                <span>•</span>
                <span>Page Not Found</span>
              </div>
            </div>

            {/* Mobile Logo - Only visible on small screens */}
            <div className="lg:hidden text-center mt-12">
              <div className="flex items-center justify-center space-x-2 text-gray-500">
                <FaChurch size={20} />
                <span className="text-sm">Adom Chapel Management System</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;